<template>
  <div class="edit">
    <div class="edit_top"></div>
    <div class="detail">
      <div class="detail_contents">
        <div class="detail_top">
          <div class="image">
            <img :src="profilePicture" />
          </div>
          <div class="profile_content">
            <div class="pronunciation">
              {{ pronunciation }}
            </div>
            <div class="messageHistory_name detail_top_title">
              {{ messageHistoryName }}
            </div>
            <div class="messageHistory_job_label detail_label">
              {{ jobLabel }}
            </div>
            <div class="messageHistory_job">
              {{ job }}
            </div>
          </div>
        </div>
        <div class="detail_bottom_messageHistoryDetail">
          <div class="user_id_label detail_label">
            {{ userIdLabel }}
          </div>
          <div class="user_id">
            {{ userId }}
          </div>
          <div class="detail_bottom_messageHistoryDetail_title detail_label">
            {{ senderLabel }}
          </div>
          <div class="sender">
            {{ adminUserName }}
          </div>
          <div class="detail_bottom_messageHistoryDetail_title detail_label">
            {{ telLabel }}
          </div>
          <div class="tel">
            {{ phoneNumber }}
          </div>
          <div class="detail_bottom_messageHistoryDetail_title detail_label">
            {{ sendDateTimeLabel }}
          </div>
          <div class="send_datetime">
            {{ sendDateTime }}
          </div>
          <div class="detail_bottom_messageHistoryDetail_title detail_label">
            {{ messageLabel }}
          </div>
          <div class="message">{{ message }}</div>
        </div>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import completeModalWindow from '../modalWindow/finishModalWindow.vue'

export default {
  data() {
    return {
      edit: '編集',
      userIdLabel: 'ユーザID',
      jobLabel: '職種',
      senderLabel: '送信者',
      telLabel: '送信先電話番号',
      sendDateTimeLabel: '送信日時',
      messageLabel: 'メッセージ',
      showloadingModal: false,
      failureWord: '',
      showFailureModal: false
    }
  },
  computed: {
    pronunciation() {
      return this.$store.state.messageHistory.messageHistory.pronunciation
    },
    messageHistoryName() {
      return (
        this.$store.state.messageHistory.messageHistory.familyName +
        this.$store.state.messageHistory.messageHistory.name
      )
    },
    profilePicture() {
      return this.$store.state.messageHistory.changeThumbnailPhotograph
    },
    userId() {
      return this.$store.state.messageHistory.messageHistory.userId
    },
    job() {
      return this.$store.state.messageHistory.messageHistory.job
    },
    adminUserName() {
      return this.$store.state.messageHistory.messageHistory.adminUserName
    },
    phoneNumber() {
      return this.$store.state.messageHistory.messageHistory.phoneNumber
    },
    sendDateTime() {
      if (
        this.$store.state.messageHistory.messageHistory.sendDateTime != null
      ) {
        var date = new Date(
          this.$store.state.messageHistory.messageHistory.sendDateTime
        )
        return `${date.getFullYear()}/${(date.getMonth() + 1)
          .toString()
          .padStart(2, '0')}/${date
          .getDate()
          .toString()
          .padStart(2, '0')} ${date
          .getHours()
          .toString()
          .padStart(2, '0')}:${date
          .getMinutes()
          .toString()
          .padStart(2, '0')}`
      } else {
        return ''
      }
    },
    message() {
      let message = this.$store.state.messageHistory.messageHistory.message
      if (!message || typeof message !== 'string') {
        return message
      }
      return message.replace(/^\(|\)$/g, '')
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    fileDownloadErrorFlg() {
      return this.$store.state.messageHistory.fileDownloadErrorFlg
    }
  },
  components: {
    completeModalWindow
  },
  async created() {
    if (this.fileDownloadErrorFlg) {
      this.$store.dispatch('messageHistory/setNoimageChangeThumbnailPhotograph')
      let eventNumber = this.$store.state.error.errorCode.errorCode_720001
      let eventType = 3
      let reason = 'MSGCRC0196 '
      this.failureWord =
        this.errorMsg.MSGCRC0196.name +
        this.errorMsg.MSGCRC0196.value +
        'エラーコード：{' +
        eventNumber +
        '}'
      try {
        this.$store.dispatch('masters/writeLog', {
          eventNumber,
          eventType,
          reason
        })
      } catch (error) {}
      this.$store.dispatch('messageHistory/fileDownloadErrorFlg', false)
      this.showFailureModal = true
    }
  },
  methods: {
    stayClose(e) {
      this.showFailureModal = false
    }
  }
}
</script>

<style scoped>
.detail_contents {
  width: calc(100% - 25px);
  height: calc(100% - 30px);
  margin: 0;
  padding: 25px 0 0 25px;
}
.detail_top {
  padding-bottom: 25px;
  width: calc(100% - 25px);
}
.profile_content {
  display: inline-block;
  padding: 0 0 0 25px;
  vertical-align: middle;
  width: calc(75% - 30px);
}
.pronunciation {
  font-size: 14px;
  color: #000;
  padding-bottom: 10px;
}
.messageHistory_name {
  padding-bottom: 15px;
}
.messageHistory_job_label {
  color: #b9b9b9;
}
.user_id {
  font-size: 22px;
  color: #000;
}
.detail_bottom_messageHistoryDetail {
  width: 95%;
  color: #000;
  padding-top: 25px;
}
.detail_bottom_messageHistoryDetail_title {
  font-size: 14px;
  padding-top: 20px;
}
.message {
  min-height: 30px;
  overflow-wrap: anywhere;
  white-space: pre-line;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/messageHistory/messageHistoryDetail.vue